import { render, staticRenderFns } from "./CourseForm.vue?vue&type=template&id=026e9ff6"
import script from "./CourseForm.vue?vue&type=script&lang=js"
export * from "./CourseForm.vue?vue&type=script&lang=js"
import style0 from "./CourseForm.vue?vue&type=style&index=0&id=026e9ff6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports